(function () {
  const $leaderCards = $('.leader-card');

  $leaderCards.each(function () {
    const $card = $(this);
    const $readMoreBtn = $card.find('.read-more_button');
    const $popup = $card.find('.leadership-bio__popup');
    const $closeBtn = $('<button class="leadership-popup-close" aria-label="Close">&times;</button>');
    const $contentContainer = $('<div class="leadership-bio__popup-content"></div>');

    // Create modal overlay and content wrapper
    const $modal = $('<div class="leadership-modal"></div>');
    const $modalContent = $('<div class="leadership-modal__content"></div>');

    // Build modal structure
    $contentContainer.append($popup.html());
    $modalContent.append($closeBtn);
    $modalContent.append($contentContainer);
    $modal.append($modalContent);
    $('body').append($modal);

    // Open modal on read more click
    $readMoreBtn.on('click', function (e) {
      e.preventDefault();
      $modal.addClass('is-active');
      $('body').addClass('modal-open');
    });

    // Close modal on close button click
    $closeBtn.on('click', function () {
      $modal.removeClass('is-active');
      $('body').removeClass('modal-open');
    });

    // Close modal on overlay click
    $modal.on('click', function (e) {
      if ($(e.target).is('.leadership-modal')) {
        $modal.removeClass('is-active');
        $('body').removeClass('modal-open');
      }
    });

    // Close modal on ESC key
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $modal.hasClass('is-active')) {
        $modal.removeClass('is-active');
        $('body').removeClass('modal-open');
      }
    });
  });
})();
